module.exports = __webpack_public_path__ + "img/horizontal_bar_mockup.b619a73c.svg";